export { default } from './InputWithOptions';
